module.exports = __webpack_public_path__ + "images/user-nav-icon-2a7c4425.svg";